<template>
  <div class="resume flex" v-if="resumesList">
    <div class="resume_left loads" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <section class="intention ">
        <div class="title">
          <h2>求职意向</h2>
        </div>
        <div class="info relative">
          <!-- <span @click="edit(2,'编辑求职意向',twoList.id)" class="edit">
          </span> -->
          <div class="job-form">
            <el-form :model="form" :rules="error" ref="jobform" label-width="85px" class="form">
              <el-form-item label="求职状态" prop="jobStatus" required>
                <MulSelect :code="'job_invia'" placeholder="请选择求职状态" @setMValue="setSelectValue($event,'jobStatus')" :defaultValue="form.jobStatus"></MulSelect>
              </el-form-item>
              <el-form-item label="期望地点" prop="provinceid" required>
                <ThreeLink :codeType="'provinceid'" :codeLevel="'3'" placeholder="请选择期望地点" @setMValue="setScasValue($event,form,['provinceid','cityid','threeCityid'])"
                  :defaultValue="[form.provinceid,form.cityid,form.threeCityid]"></ThreeLink>
              </el-form-item>
              <el-form-item label="期望薪资" prop="salary" required>
                <MulSelect :code="'user_salary'" placeholder="请选择期望薪资" @setMValue="setSelectValue($event,'salary')" :defaultValue="form.salary"></MulSelect>
              </el-form-item>
              <el-form-item label="工作性质" prop="jobType" required>
                <MulSelect :code="'job_type'" placeholder="请选择工作性质" @setMValue="setSelectValue($event,'jobType')" :defaultValue="form.jobType"></MulSelect>
              </el-form-item>
              <el-form-item label="期望行业" prop="hyTop" required>
                <ThreeLink :codeType="'hy1'" :codeLevel="'2'" @setMValue="setScasValue($event,form,['hyTop','hy'])" :defaultValue="[form.hyTop,form.hy]"></ThreeLink>
              </el-form-item>
              <el-form-item label="期望职位" prop="jobTop" required>
                <ThreeLink :codeType="'job1'" :codeLevel="'3'" placeholder="请选择期望职位" @setMValue="setScasValue($event,form,['jobTop','jobNext','jobPost'])"
                  :defaultValue="[form.jobTop,form.jobNext,form.jobPost]"></ThreeLink>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </section>
      <section class="intention ">
        <div class="title">
          <h2>我的简历</h2>
          <span style="cursor: pointer;" @click="goRouter('/center/resume',memberId,userType)" class="edit">
            <img src="~/static/center/editor.png" alt class="middle" />修改
          </span>
        </div>
        <div class="resume_content" style="border:1px solid #DCDFE6;padding:20px">
          <section class="header flex" v-if="disabledOutDTO">
            <div class="imgs">
              <img :src="disabledOutDTO.imageurl" alt class="avatar err_avatar" />
            </div>
            <ul class="info">
              <li class="flex">
                <h2>
                  {{ disabledOutDTO.userName }}
                  <small>{{ disabledOutDTO.jobStatus }}</small>
                </h2>
              </li>
              <li class="edu">
                <span>
                  {{ disabledOutDTO.sex }}
                  <span>/</span>
                </span>
                <span v-if="disabledOutDTO.age">
                  {{ disabledOutDTO.age }}岁
                </span>
                <span v-if="disabledOutDTO.edu"><span>/</span>{{ disabledOutDTO.edu }}</span>
                <span v-if="disabledOutDTO.exp"><span>/</span>{{ disabledOutDTO.exp }}</span>
              </li>
              <li class="level" v-for="(item, index) in disabledOutDTO.disabledType" :key="index">
                <span>
                  {{ item.disabledType }}
                  <span>/</span>
                </span>
                <span>
                  {{ item.disabledLevel }}
                  <span>/</span>
                </span>
                <span>{{ item.disabledDetail }}</span>
              </li>
              <li class="link">
                <span v-if="disabledOutDTO.linkPhone">
                  <el-tooltip class="item" effect="dark" content="想和求职者取得联系吗？您可通过发送邀请面试哦，求职者看到您的邀请后会与您联系！" placement="top-start">
                    <div class="div">
                      <img src="~/static/center/phone.svg" alt />
                      {{ disabledOutDTO.linkPhone }}
                    </div>
                  </el-tooltip>
                </span>
                <span v-if="disabledOutDTO.linkEmail">
                  <el-tooltip class="item" effect="dark" content="想和求职者取得联系吗？您可通过发送邀请面试哦，求职者看到您的邀请后会与您联系！" placement="top-start">
                    <div class="div">
                      <img src="~/static/center/email.svg" alt />
                      {{ disabledOutDTO.linkEmail }}
                    </div>
                  </el-tooltip>
                </span>
                <el-button type="primary" @click="isShow = true" v-if="userType == 2">邀请面试</el-button>
                <span class="file" v-if="disabledOutDTO.fileResume != 0"><a :href="disabledOutDTO.fileResume" target="_blank"><img src="~/static/center/icon4.png"
                      alt="">附件简历</a></span>
              </li>
            </ul>
          </section>

          <section class="experience">
            <div class="title">
              <h2>工作经验</h2>
            </div>
            <div v-for="(item, index) in resumeWorkOutDTOS" :key="index">
              <div class="info">
                <h2 class="relative">
                  {{ item.companyName }}
                  <small class="time">{{ item.beginTime }}~{{ item.endTime }}</small>
                </h2>
                <h3>{{ item.jobName }}</h3>
                <p class="p1">
                  <span>所属部门：{{ item.department }}</span>
                  <span>所属行业：{{ item.hyTop }}</span>
                </p>
                <p class="p2" v-for="(lables, index) in item.skillBar" :key="index">
                  技能标签：
                  <span>JavaScript</span>
                  <span>nodeJs</span>
                  <span>vue</span>
                </p>
                <h4>职位描述</h4>
                <div class="text" v-html="item.jobContent"></div>
              </div>
            </div>
          </section>
          <section class="education">
            <div class="title">
              <h2>教育经历</h2>
            </div>
            <div v-for="(item, index) in resumeEduOutDTOS" :key="index">
              <div class="info relative">
                <p>
                  <span>{{ item.schoolName }}</span>
                  <span>{{ item.majorName }}</span>
                  <span>{{ item.edu }}</span>
                  <span>{{ item.benginTime }}-{{ item.endTime }}</span>
                </p>
                <div class="text">
                  <h4>在校经历：</h4>
                  <p v-html="item.schoolExperience"></p>
                </div>
              </div>
            </div>
          </section>
          <section class="education train">
            <div class="title">
              <h2>培训经历</h2>
            </div>
            <div v-for="(item, index) in resumeTrainOutDTOS" :key="index">
              <div class="info relative">
                <p>
                  <span>{{ item.trainOrganization }}</span>
                  <span>{{ item.trainCourse }}</span>
                  <span>{{ item.beginTime }}-{{ item.endTime }}</span>
                </p>
                <h4>培训内容</h4>
                <div class="text marT20" v-html="item.trainContent"></div>
              </div>
            </div>
          </section>

        </div>
      </section>

    </div>

    <el-dialog :title="title" :visible.sync="isShow" :width="active == 1?'950px':'600px'" :before-close="handleClose" v-if="isShow">
      <div class="dialog_content">
        <Info v-if="active == 1" :oneList="oneList" @close="close"></Info>
        <Intention v-else-if="active == 2" @close="close" :id="isId"></Intention>
        <work v-else-if="active == 3" @close="close" :id="isId"></work>
        <education v-else-if="active == 4" @close="close" :id="isId"></education>
        <train v-else-if="active == 5" @close="close" :id="isId"></train>
        <skill v-else-if="active == 6" @close="close" :id="isId"></skill>
        <certificate v-else-if="active == 7" @close="close" :id="isId"></certificate>
        <language v-else-if="active == 8" @close="close" :id="isId"></language>
        <project v-else-if="active == 9" @close="close" :id="isId"></project>
        <personInfo v-else @close="close" :id="isId" :description="threeList.description"></personInfo>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Info from '@/components/center/resume/info';
import Intention from '@/components/center/resume/intention';
import work from '@/components/center/resume/work';
import education from '@/components/center/resume/education';
import train from '@/components/center/resume/train';
import skill from '@/components/center/resume/skill';
import certificate from '@/components/center/resume/certificate';
import language from '@/components/center/resume/language';
import project from '@/components/center/resume/project';
import personInfo from '@/components/center/resume/personInfo';
import MulSelect from '@/components/selectComponents/MulSelect';
import ThreeLink from '@/components/selectComponents/ThreeLink';

export default {
  name: 'resume',
  components: {
    Info,
    Intention,
    work,
    education,
    train,
    skill,
    certificate,
    language,
    project,
    personInfo,
    MulSelect,
    ThreeLink
  },
  data() {
    return {
      isId: '',
      loading: false,
      form: {
        jobStatus: '',
        provinceid: '',
        cityid: '',
        threeCityid: '',
        addressDetail: '',
        salary: '',
        jobType: '',
        hyTop: '',
        hyTwo: '',
        hyThree: '',
        jobTop: '',
        jobNext: '',
        jobPost: ''
      },
      error: {
        jobStatus: [{ required: true, message: '求职状态不能为空', trigger: 'change' }],
        salary: [{ required: true, message: '期望薪资不能为空', trigger: 'change' }],
        provinceid: [{ required: true, message: '期望地点不能为空', trigger: 'change' }],
        jobType: [{ required: true, message: '工作性质不能为空', trigger: 'change' }],
        hyTop: [{ required: true, message: '期望行业不能为空', trigger: 'change' }],
        jobTop: [{ required: true, message: '期望职位不能为空', trigger: 'change' }]
      },
      value: '',
      width: '70',
      active: 1,
      isShow: false,
      imageurl: '',
      title: '',
      resumesList: [],
      oneList: [],
      twoList: [],
      threeList: {},
      fourList: [],
      fiveList: [],
      sixList: [],
      sevenList: [],
      eigList: [],
      nineList: [],
      tenList: [],
      memberId: '',
      userType: '',
      resumesList: [],
      disabledOutDTO: [],
      resumeExpectOutDTO: [],
      resumeDescriptionOutDTO: {},
      resumeWorkOutDTOS: [],
      resumeEduOutDTOS: [],
      resumeTrainOutDTOS: [],
      resumeSkillOutDTOS: [],
      resumeCertOutDTOS: [],
      resumeLanguageOutDTOS: [],
      resumeProjectOutDTOS: []
    };
  },
  methods: {
    setSelectValue(val, key) {
      this.form[key] = val;
    },
    setScasValue(event, form, keys) {
      for (let i = 0; i < keys.length; i++) {
        let value = event[i];
        if (!value) {
          value = '';
        }
        let key = keys[i];
        form[key] = value;
      }
    },
    handleSave() {
      let that = this;
      this.$refs['jobform'].validate(async valid => {
        try {
          if (valid) {
            let res = await that.$api.resumeExpect(that.form);
            if (res.data.success) {
              that.$message.success(res.data.msg);
            }
          } else {
            // that.$message.error('error submit!!');
            return false;
          }
        } catch (err) {
          alert(err);
        }
      });
    },
    // 基本信息
    disableResume() {
      let params = {
        memberId: this.memberId,
        userType: this.userType
      };

      this.loading = true;
      this.$api
        .disableResume(params)
        .then(res => {
          console.log('我的简历', res.data);
          this.resumesList = res.data.data;
          this.oneList = this.resumesList.disabledOutDTO;
          this.twoList = this.resumesList.resumeExpectOutDTO;
          this.threeList = this.resumesList.resumeDescriptionOutDTO;
          this.fourList = this.resumesList.resumeWorkOutDTOS;
          this.fiveList = this.resumesList.resumeEduOutDTOS;
          this.sixList = this.resumesList.resumeTrainOutDTOS;
          this.sevenList = this.resumesList.resumeSkillOutDTOS;
          this.eigList = this.resumesList.resumeCertOutDTOS;
          this.nineList = this.resumesList.resumeLanguageOutDTOS;
          this.tenList = this.resumesList.resumeProjectOutDTOS;
          // 我的简历
          this.resumesList = res.data.data;
          this.disabledOutDTO = this.resumesList.disabledOutDTO;
          document.title =
            this.disabledOutDTO.userName +
              '-河南省残疾人就业创业网络服务平台——中国残联官方残疾人求职网站' || '个人简历';
          this.resumeExpectOutDTO = this.resumesList.resumeExpectOutDTO;
          this.resumeDescriptionOutDTO = this.resumesList.resumeDescriptionOutDTO;
          this.resumeWorkOutDTOS = this.resumesList.resumeWorkOutDTOS;
          this.resumeEduOutDTOS = this.resumesList.resumeEduOutDTOS;
          this.resumeTrainOutDTOS = this.resumesList.resumeTrainOutDTOS;
          this.resumeSkillOutDTOS = this.resumesList.resumeSkillOutDTOS;
          this.resumeCertOutDTOS = this.resumesList.resumeCertOutDTOS;
          this.resumeLanguageOutDTOS = this.resumesList.resumeLanguageOutDTOS;
          this.resumeProjectOutDTOS = this.resumesList.resumeProjectOutDTOS;
          this.loading = false;
        })
        .catch(error => {
          console.log('错误了', error);
          this.loading = false;
        });
    },
    // 删除
    delate(id, status) {
      // 工作经历
      this.id = id;

      this.$confirm('此操作将永久删除该项内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          if (status == '1') {
            let res = await this.$api.deleteMyResumeWork({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          } else if (status == '2') {
            let res = await this.$api.deleteMyResumeEdu({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          } else if (status == '3') {
            let res = await this.$api.deleteMyResumeTrain({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          } else if (status == '4') {
            this.id = id;
            let res = await this.$api.deleteMyResumeSkill({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          } else if (status == '5') {
            this.id = id;
            let res = await this.$api.deleteMyResumeCert({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          } else if (status == '6') {
            this.id = id;
            let res = await this.$api.deleteMyResumeLanguage({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          } else {
            let res = await this.$api.deleteMyResumeProject({ id: this.id });
            if (res.data.success) {
              this.$message.success('删除成功');
            }
          }
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.disableResume();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    // 刷新简历
    async refreshResume() {
      let res = await this.$api.refreshResume();
      if (res.data.success) {
        this.$message.success('刷新成功');
      }
    },
    setSelectValue(val, key) {
      this.form[key] = val;
    },
    edit(i, title, id) {
      this.active = i;
      this.title = title;
      this.isId = id;
      this.isShow = true;
    },
    remove() {},
    goRouter(url, memberId, userType) {
      const { href } = this.$router.resolve({
        path: url,
        query: {
          id: memberId,
          userType: userType
        }
      });
      window.open(href, '_blank');
    },
    handleClose() {
      this.isShow = false;
    },
    close() {
      this.isShow = false;
    },
    handleAvatarSuccess(res, file) {
      if (res.success == false) return this.$message.error(res.msg);
      this.$api.saveDisabled({ fileResume: res.msg }).then(res => {
        if (res.data.success) {
          this.$message.success('上传附件简历成功！');
          this.disableResume();
        }
      });
    },
    async myResumeExpect() {
      // let disabledId=this.id
      try {
        let res = await this.$api.myResumeExpect();
        console.log(res);
        this.form = { ...this.form, ...res.data.data };
      } catch (error) {
        alert(error);
      }
    }
  },
  created() {
    // if (this.$store.state.login) {
    //   let memberId = this.$store.state.login.userInfo.id;
    //   this.memberId = memberId;
    //   let userType = this.$store.state.login.userInfo.userType;
    //   this.userType = userType;
    // }
    let login = JSON.parse(localStorage.getItem('userInfo') || {});
    if (login) {
      this.memberId = login.id;
      this.userType = login.userType;
    }
    this.disableResume();
    this.myResumeExpect();
  }
};
</script>

<style scoped lang="less">
// @import '~assets/css/center/center.less';

/deep/ .el-dialog__body {
  padding: 0px;
}

/deep/ .el-loading-spinner {
  top: 12%;
}
.resume {
  width: 1000px;
  margin: -20px auto 0;
  padding: 0;
  background: white;
  .job-form {
    .el-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 50%;
        .el-select,
        .el-cascader {
          width: 90%;
        }
      }
    }
  }
  h1 {
    margin-bottom: 30px;
  }
  section {
    padding: 20px 0;
    // margin: 0 20px;
    border-bottom: 1px dashed #e1e1e1;
    .title {
      display: flex;
      justify-content: space-between;
      position: relative;
      padding-bottom: 10px;
      h2 {
        font-size: 18px;
      }
    }
    p.p_list {
      span {
        position: relative;
        color: #666666;
        padding-right: 20px;
      }
      span::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 1px;
        height: 14px;
        background: #666666;
      }
      span:last-child::after {
        display: none;
      }
    }
  }
  section:last-child {
    border: none;
  }
  .resume_content {
    flex: 1;
    .header {
      .avatar {
        width: 80px;
        height: 80px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        margin-right: 20px;
        vertical-align: top;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        display: inline-block;
        li {
          padding-top: 10px;
        }
        li {
          h2 {
            font-size: 20px;
            margin-right: 10px;
          }
          .select {
            width: 136px;
            margin-right: 10px;
          }
          .edit {
            cursor: pointer;
            img {
              margin-right: 5px;
            }
            color: #00924c;
          }
        }
        .edu {
          padding-top: 5px;
          span {
            span {
              color: #999999;
              padding: 0 10px;
            }
          }
        }
        .level {
          padding-top: 5px;
          color: #666666;
          font-size: 12px;
          span {
            padding: 0 2px;
          }
        }
        .link {
          span {
            display: inline-block;
            margin-right: 40px;
            color: #666666;
            cursor: pointer;
            img {
              width: 24px;
              vertical-align: middle;
              transform: translateY(-1px);
            }
          }
          .file {
            display: inline-flex;
            align-items: center;
            margin-left: 20px;
            img {
              width: 18px;
              margin-right: 5px;
            }
            a {
              color: #00924b;
            }
          }
        }
      }
    }
    // //残疾情况
    // .situation {
    // }
    //求职意向
    .intention {
      ul {
        display: flex;
        width: 70%;
        justify-content: space-between;
        li {
          line-height: 2.5em;

          span {
            color: #666666;
            text-align: left;
          }
        }
      }
    }
    //工作经验
    .experience {
      .info {
        h2 {
          font-size: 16px;
          padding: 10px 0;
          small {
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            padding-left: 10px;
          }
          p {
            position: absolute;
            top: 10px;
            right: 0;
            color: #666666;
            font-weight: 400;
            cursor: pointer;
            span {
              padding-left: 10px;
              font-size: 14px;
              color: #00924c;
              i {
                font-size: 16px;
                margin-right: 5px;
              }
            }
            span:first-child {
              padding-right: 30px;
            }
          }
        }
        h3 {
          font-size: 14px;
          padding-bottom: 5px;
        }
        h4 {
          margin-top: 10px;
        }
        .p1 {
          font-weight: 400;
          span {
            padding-right: 50px;
          }
        }
        .p2 {
          padding: 20px 0;
          span {
            display: inline-block;
            font-size: 12px;
            padding: 0 10px;
            border: 1px solid #e1e1e1;
            -webkit-border-radius: 2px;
            -moz-border-radius: 2px;
            border-radius: 2px;
            color: #666666;
            margin-right: 5px;
          }
        }
      }
    }
    //  教育经历
    .education {
      .info {
        margin-top: 5px;
        border-bottom: 1px dotted #dfdfdf;
        padding-bottom: 5px;
        color: #666666;
        span {
          padding-right: 50px;
          i {
            padding-right: 10px;
          }
        }
      }
      .info:last-child {
        border: none;
      }
      h4 {
        margin-top: 5px;
        font-weight: 500;
        margin-bottom: 3px;
      }
      .clicks {
        position: absolute;
        top: 0;
        right: 0;
        .edit {
          padding-right: 30px;
          cursor: pointer;
          i {
            padding-right: 5px;
          }
          color: #00924c;
        }
        .edit:last-child {
          padding-right: 0;
        }
      }
    }
    .train {
      h4 {
        font-weight: bold;
        color: #000000;
      }
      .text {
        margin-top: 0;
      }
    }
  }
}
</style>
